import { z } from "zod";

/** Face/body view a drawing is made on — mirrors the DB enum. */
export const bodyDrawingViewSchema = z.enum([
	"face_front",
	"face_left",
	"face_right",
	"body_front",
	"body_back",
	"scalp",
	"hands",
	"custom",
]);
export type BodyDrawingView = z.infer<typeof bodyDrawingViewSchema>;

/** Vector annotation payload (normalized 0..1000 viewBox). */
export const bodyDrawingStrokesSchema = z.object({
	paths: z
		.array(
			z.object({
				d: z.string().max(20000),
				color: z.string().max(32),
				width: z.number().min(0).max(100),
			}),
		)
		.max(500),
	markers: z
		.array(
			z.object({
				x: z.number(),
				y: z.number(),
				label: z.string().max(60).optional(),
				color: z.string().max(32).optional(),
			}),
		)
		.max(200)
		.optional(),
});
export type BodyDrawingStrokes = z.infer<typeof bodyDrawingStrokesSchema>;

export const bodyDrawingApiSchema = z.object({
	id: z.string().uuid(),
	clinic_id: z.string().uuid(),
	patient_id: z.string().uuid(),
	visit_id: z.string().uuid().nullable(),
	view: bodyDrawingViewSchema,
	title: z.string().nullable(),
	strokes: bodyDrawingStrokesSchema,
	created_by_member_id: z.string().uuid().nullable(),
	created_by_name: z.string().nullable(),
	created_at: z.string().datetime(),
	updated_at: z.string().datetime(),
});
export type BodyDrawingApi = z.infer<typeof bodyDrawingApiSchema>;

export const createBodyDrawingInputSchema = z.object({
	patient_id: z.string().uuid(),
	visit_id: z.string().uuid().optional(),
	view: bodyDrawingViewSchema.default("face_front"),
	title: z.string().max(160).optional(),
	strokes: bodyDrawingStrokesSchema,
});
export type CreateBodyDrawingInput = z.infer<
	typeof createBodyDrawingInputSchema
>;

export const updateBodyDrawingInputSchema = z.object({
	view: bodyDrawingViewSchema.optional(),
	title: z.string().max(160).nullable().optional(),
	strokes: bodyDrawingStrokesSchema.optional(),
});
export type UpdateBodyDrawingInput = z.infer<
	typeof updateBodyDrawingInputSchema
>;
